import filter from "lodash/filter";
import find from "lodash/find";
import map from "lodash/map";
import { Inline, Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { Activity, CustomType } from "PFCore/types";
import { useTranslation } from "react-i18next";

type ActivityAudienceProps = {
  activity: Activity;
};

export const ActivityAudience = ({ activity }: ActivityAudienceProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.details.audience" });
  const { customTypes } = useCustomTypes();

  const broadcastTypes = filter(customTypes, (ct) => find(ct.sections, { key: "broadcast" }));

  return (
    <Stack gap="spacingLg" qaId="ActivitySummary-Audience">
      <Inline spread>
        <Typography variant="bodyBold">{t("title")}</Typography>
        <Inline alignItems="center" gap="spacingSm">
          <Typography variant="bodyRegular">
            {activity.private ? t("privateHeading") : t("publicHeading")}
          </Typography>
          <TooltipIcon content={activity.private ? t("privateHint") : t("publicHint")} />
        </Inline>
      </Inline>

      {activity?.private && activity?.audiences?.length > 0 && (
        <Stack>
          <Typography variant="bodyRegular">{t("audiences")}</Typography>
          {activity.audiences.map((audience, index) => (
            <Tile key={index} border variant="default" paddingVariant="md">
              <Stack>
                {map(audience, (values, name) => {
                  const type = find(broadcastTypes, { name }) as CustomType;

                  return (
                    <Inline key={name}>
                      <Typography variant="bodyBold">
                        {type?.display_as || name}:{" "}
                        <Typography variant="bodyRegular" tag="span">
                          {map(values, "text").join(", ")}
                        </Typography>
                      </Typography>
                    </Inline>
                  );
                })}
              </Stack>
            </Tile>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
